import { getComponent } from '../utils'
import { h } from 'vue'
import { prefix } from '../prefix'
import Layout from '@/layouts/main-layout.vue'
import { UserOutlined } from '@ant-design/icons-vue'
import { useIdentityStore } from '@/stores/identity/auth'
import type { RouteRecordRaw } from 'vue-router'
import PublicLayout from '@/layouts/public-layout.vue'
import AuthLayout from '@/layouts/auth-layout.vue'

export const user_routes: RouteRecordRaw[] = [
  {
    path: '/user/list',
    name: 'user-list',
    component: () => getComponent(`pages/user/user-list.vue`),
    meta: {
      title: () => 'Users',
      layout: Layout,
      is_public: false,
      menu: {
        key: 'Users',
        label: 'Users',
        icon: () => h(UserOutlined),
        path: `${prefix}/user/list`,
        separate: true,
        condition: () => {
          const identity_store = useIdentityStore()
          return (
            identity_store.auth.user.roles.includes('org_admin') ||
            identity_store.auth.user.roles.includes('super_admin')
          )
        },
      },
    },
  },
  {
    path: '/user/:id(\\d+)+',
    name: 'user-details',
    component: () => getComponent(`pages/user/user-details.vue`),
    meta: {
      title: ({ id }: { id: string }) => `User #${id}`,
      layout: Layout,
      is_public: false,
    },
  },
  {
    path: '/user/new',
    name: 'user-new',
    component: () => getComponent(`pages/user/user-new.vue`),
    meta: {
      title: () => `New User`,
      layout: Layout,
      is_public: false,
    },
  },
  {
    path: '/user/:id(\\d+)+/edit',
    name: 'user-edit',
    component: () => getComponent(`pages/user/user-edit.vue`),
    meta: {
      title: () => `Edit User`,
      layout: Layout,
      is_public: false,
    },
  },
  {
    path: '/user/verify',
    name: 'user-verify',
    component: () => getComponent(`pages/user/user-verify.vue`),
    meta: {
      title: () => `Verify email`,
      layout: AuthLayout,
      is_public: true,
    },
  },
]
